import { createAction, props } from '@ngrx/store';

import { MapListEntity } from '../components/map-list/map-list.entity';

export enum MapActions {
	InitMapList = '[Map] get map list',
	RefreshMapList = '[BE][Map] refresh map list',
	FetchMapListSuccess = '[BE][Map] fetch map list sucess',
	FetchMapListFail = '[BE][Map] fetch map list fail',
	NavigateToMapCreateRoute = '[Map] navigate to map create route',
	NavigateToMapRoute = '[Map] navigate to map route',
	ToggleMapStatus = '[Map] toggle map status',
	OpenDeleteConfirmationPopup = '[Map] open delete confirm popup',
	DeleteMap = '[Map] delete map',
	BulkDeleteMaps = '[Map] delete many maps',
	DeleteMapSuccess = '[BE][Map] delete map success',
	DeleteMapFail = '[BE][Map] delete map fail',
	DuplicateMap = '[Map] duplicate map',
	DuplicateMapSuccess = '[BE][Map] duplicate map success',
	DuplicateMapFail = '[BE][Map] duplicate map fail',
}

export const initMapList = createAction(MapActions.InitMapList);

export const refreshMapList = createAction(MapActions.RefreshMapList);

export const fetchMapListSuccess = createAction(
	MapActions.FetchMapListSuccess,
	props<{ mapList: MapListEntity }>()
);

export const fetchMapListFail = createAction(
	MapActions.FetchMapListFail,
	props<{ error: unknown }>()
);

export const navigateToMapCreate = createAction(
	MapActions.NavigateToMapCreateRoute
);

export const navigateToMap = createAction(
	MapActions.NavigateToMapRoute,
	props<{ id: number; goToVisuTab: boolean }>()
);

export const toggleMapStatus = createAction(
	MapActions.ToggleMapStatus,
	props<{ mapId: number }>()
);

export const openDeleteConfirmationPopup = createAction(
	MapActions.OpenDeleteConfirmationPopup,
	props<{
		mapId: Array<number>;
		mapLabel: string;
	}>()
);

export const deleteMap = createAction(
	MapActions.DeleteMap,
	props<{ mapId: number }>()
);

export const bulkDeleteMaps = createAction(
	MapActions.BulkDeleteMaps,
	props<{ mapIds: Array<number> }>()
);

export const deleteMapSuccess = createAction(MapActions.DeleteMapSuccess);

export const deleteMapFail = createAction(
	MapActions.DeleteMapFail,
	props<{ error: unknown }>()
);

export const duplicateMap = createAction(
	MapActions.DuplicateMap,
	props<{ mapId: number }>()
);

export const duplicateMapSuccess = createAction(
	MapActions.DuplicateMapSuccess,
	props<{ id: number }>()
);

export const duplicateMapFail = createAction(
	MapActions.DuplicateMapFail,
	props<{ error: unknown }>()
);
